// FieldLabel — uppercase mono micro-label + optional infoTip / required.

import * as React from "react";
import { InfoTip } from "./InfoTip";

type Props = {
  children: React.ReactNode;
  hint?: string;
  infoTip?: React.ReactNode;
  required?: boolean;
};

export function FieldLabel({ children, hint, infoTip, required }: Props) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <span
        className="mono"
        style={{
          fontSize: 9.5,
          color: "var(--ink-4)",
          textTransform: "uppercase",
          letterSpacing: "0.1em",
          fontWeight: 600,
        }}
      >
        {children}
        {required && <span style={{ color: "#a14b3a", marginLeft: 3 }}>✱</span>}
      </span>
      {infoTip && <InfoTip content={infoTip} />}
      {hint && (
        <span style={{ fontSize: 10.5, color: "var(--ink-4)" }}>· {hint}</span>
      )}
    </div>
  );
}
